import React from "react";
import DataSummaryTable from "../components/table/DataSummaryTable";
import { useGetTrackInitiationsQuery } from "../redux/service/modules/dashboard";
import {customCellColor, getHighlightStyle} from '../utils/commonUtils';
import { useLazyGetLazyTrackInitiationsQuery } from "../redux/service/modules/dashboard/lazzyQuery";
const TrackInitiationsTable = ({initialDateRange, filters}) => {

  const highlightRules = [
    {
      column: "row_color",
      condition: "customRowColor",
      fetchCustomRowColor: (row) => getHighlightStyle(row.row_color),
    }
  ]

  const columnTypeMapping = {
    thematics: {
      columns: ["thematics_planned", "thematics_actual", "thematics_lag"],
      colorKey: "thematics_color",
    },
    initiations: {
      columns: ["initiation_planned", "initiation_actual", "initiation_lag"],
      colorKey: "initiation_color",
    },
  };
  const [exportToExcelQuery] = useLazyGetLazyTrackInitiationsQuery()
  return (
    <DataSummaryTable
      title="Track Initiations"
      initialDateRange={initialDateRange}
      queryHook={useGetTrackInitiationsQuery}
      maxRows={5}
      headerFontSizes={['18px', '14px', '0px']}
      headerHeights={["1.5rem", "1rem", "1rem"]}
      headerPadding={["8px 5px", "8px 5px", "8px 5px"]}
      headerGap={true}
      filters={filters}
      highlightRules={highlightRules}
      exportToExcelQuery={exportToExcelQuery}
      customCellColor={(header, row) => customCellColor(header, row, columnTypeMapping)}
    />
  );
};

export default TrackInitiationsTable;
